export default __webpack_public_path__ + "static/media/kstadium-mark.c6a39d9d.png";